function initPbCopyLink(): void {
  const btn = document.querySelector<HTMLButtonElement>("[data-copy-url]");
  if (!btn) return;

  btn.addEventListener("click", () => {
    const url = btn.dataset.copyUrl;
    if (!url || !navigator.clipboard?.writeText) return;

    navigator.clipboard.writeText(url).then(() => {
      const tip = btn.querySelector<HTMLElement>(".share-copy__feedback");
      if (!tip) return;

      tip.hidden = false;

      const prev = Number(tip.dataset.tid || "0");
      if (prev) window.clearTimeout(prev);

      tip.dataset.tid = String(
        window.setTimeout(() => {
          tip.hidden = true;
        }, 1000),
      );
    });
  });
}

initPbCopyLink();